<script>
import {
  maxValue,
  minValue,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import { shouldBeYesIf } from "@/validations/shouldBeYesIf";

export default {
  methods: {
    showAgeRequirements(design) {
      return (
        +design.age_requirement_employee_deferrals === 1 ||
        +design.age_requirement_employee_deferrals === 2
      );
    },
    ageRequirementValidations(design) {
      return {
        age_requirement_employee_deferrals: { required },
        age_requirement_years: {
          required: requiredIf(() => this.showAgeRequirements(design)),
          minValue: minValue(0),
          maxValue: maxValue(design.age_requirement_months > 0 ? 20 : 21)
        },
        age_requirement_months: {
          required: requiredIf(() => this.showAgeRequirements(design)),
          minValue: minValue(0),
          maxValue: maxValue(+design.age_requirement_years === 21 ? 0 : 12)
        },
        age_requirement_sync: {
          required: requiredIf(() => this.showAgeRequirements(design)),
          shouldBeYes: shouldBeYesIf(
            design.age_requirement_years > design.age_requirement_match_years ||
              (design.age_requirement_years ===
                design.age_requirement_match_years &&
                design.age_requirement_months >
                  design.age_requirement_match_months)
          )
        }
      };
    }
  }
};
</script>
